import React, { FC, useState } from "react";
import { FaPlus, FaTrash, FaTrashAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import ParentAccountFields from "../modal/ParentAccountFields";
import ModalButton from "../../../../components/common/form/ModalButton";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { useDeleteParentAccountByIdMutation, useGetParentAccountByIdQuery } from "../parentAccountApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

type SubdivisionDetailInfoProps = {
    parentAccountData: any; // Replace 'any' with a proper type if known
};

const SubdivisionParentAccount: FC<SubdivisionDetailInfoProps> = ({ parentAccountData }) => {


    console.log("fdfdfdfdfd",parentAccountData);

    const [deleteApi, { isLoading }] = useDeleteParentAccountByIdMutation();
    const [selectedContact, setSelectedContact] = useState(null);
    const [parentId, setParentId] = useState();
    const [show, setShow] = useState(false);

    const parentAccountByIdData = useGetParentAccountByIdQuery(parentId ?? skipToken);


    const handleDelete = (id: any) => {
        deleteApi(id);
    }
    const handleRowClick = (contactId: any) => {
        setSelectedContact(contactId);
        setParentId(contactId)
        setShow(true);
    };


    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center  border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Parent Accounts ({parentAccountData?.length || 0})</h5>
                {hasPermission(["SUBD-U"]) &&
                    <ModalButton triggerButton={<FaCirclePlus className={"text-highlight-0"}/>}
                        modal={
                            <ParentAccountFields show={true} setShow={() => {
                            }} title={"Add Parent Account"} formType={"Add"} />
                        }
                    />}
            </div>
            <div className="p-2 max-h-[150px] overflow-auto scrollbar-hide">
                <table className="w-full bg-text-0 border-b border-[rgba(0,0,0,0.1)] border">
                    <thead className="border-b-2 border-[rgba(0,0,0,0.1)]">
                        <tr>
                            {[
                                "Account No.",
                                "Rollback Status",
                                "Acct Status",
                                "Include",
                                ...(hasPermission(["SUBD-U"]) ? ["Action"] : [])
                            ].map((heading) => (
                                <th key={heading} className="text-left whitespace-nowrap">{heading}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {parentAccountData?.length === 0 ? (
                            <tr>
                                <td colSpan={13} className=" text-gray-500 p-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            parentAccountData?.map((data: any) => (
                                <tr key={data.id} className="bg-text-1">
                                    <td className="p-2 text-highlight-4 cursor-pointer" onClick={() => handleRowClick(data.id)}>
                                        {data.accountNumber}
                                    </td>
                                    <td className="p-2">{data.rollbackStatus || "-"}</td>
                                    <td className="p-2">{data.accountStatus || "-"}</td>
                                    <td className="p-2">
                                        <input
                                            type="checkbox"
                                            checked={data.included}
                                            className="mt-2"
                                            readOnly // Prevent React warning if not handling onChange
                                        />
                                    </td>
                                    <td className="p-2 text-red-600 cursor-pointer">
                                        {hasPermission(["SUBD-U"]) &&
                                            <ModalButton
                                                triggerButton={<FaTrash className="text-highlight-0" />}
                                                modal={
                                                    <ConfirmationModal
                                                        show={true}
                                                        setShow={() => { }}
                                                        title={"Delete Parent Account"}
                                                        bodyMessage={"Are you sure you want to delete this Parent Account?"}
                                                        onSubmit={() => handleDelete(data.id)}
                                                        isLoading={isLoading}
                                                    />
                                                }
                                            />}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>
            </div>
            {show && (
                <ParentAccountFields show={true} setShow={setShow} title={"Add Parent Account"} formType={"Update"} parentId={parentId}
                    parentAccountByIdData={parentAccountByIdData} />
            )}

        </div>

    );
};

export default SubdivisionParentAccount;
